'use strict';

import angular from 'angular';
import ResetPasswordSuiteWebaccessController from './reset-password-suite-webaccess.controller';

export default angular.module('conduuApp.resetPasswordSuiteWebaccess', [])
  .controller('ResetPasswordSuiteWebaccessController', ResetPasswordSuiteWebaccessController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/reset-password-suite-webaccess/index.js